import styled from 'styled-components';

export const RadioBox = styled.div`
  height: 110px;
  background: #eee;
  display: flex;
  justify-content: center;
  padding-top: 10px;
  padding-bottom: 10px;
  box-shadow: 0px 5px 5px #ccc, 0px -3px 5px #ccc;
  z-index: 2;
`;

export const RadioInner = styled.div`
  max-width: 350px;
  min-width: 350px;
  background: #fff;
  padding: 10px;
  position: relative;
  display: flex;
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 3px 8px;
`;

export const RadioInfo = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 10px;
`;

export const RadioPlayStopButton = styled.div`
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  background: #F8941C;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
`;

export const RadioInfoImage = styled.div<{ bg: string }>`
  background: url(${props => props.bg}) no-repeat;
  background-size: contain;
  width: 96px;
  height: 66px;
`;

export const VolumePercentBox = styled.div`
  width: 30px;
  margin-left: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
`;

export const RadioOptionsBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const RadioName = styled.div`
  font-family: 'MontserratMedium';
  color: #000;
  height: 25px;
  font-size: 14px;
`;

export const RadioPanel = styled.div`
  flex: 1;
  padding-left: 10px;
  display: flex;
  flex-direction: column;
`;

export const RadioPanelPlayStopButton = styled.div`
  display: flex;
  align-items: center;
`;

export const RadioPanelVolumeBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MuteButtonBox = styled.div`
  padding: 5px;
`;

export const LoaderBox = styled.div`
  padding-left: 10px;
`;

export const RangeBox = styled.div`
  flex: 1;
  padding-left: 10px;
`;

export const MuteButton = styled.div`
  cursor: pointer;
`;